export default __webpack_public_path__ + "static/media/fw_14_630_Vishnu PS.f5e4c824.pdf";